import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION11: PdfComponent = {
  type: 'section',
  id: 's11',
  title: '11. Modern Slavery',
  content: [
    {
      type: 'bulletList',
      id: 's11bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The Subscriber undertakes, warrants and represents that:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'neither it nor any of its officers, employees, agents or sub-contractors has:',
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: 'committed an offence under the Modern Slavery Act 2015 (an MSA Offence); or',
                    },
                    {
                      copy: 'been notified that it is subject to an investigation relating to an alleged MSA Offence or prosecution under the Modern Slavery Act 2015; or',
                    },
                    {
                      copy: 'is aware of any circumstances within its supply chain that could give rise to an investigation relating to an alleged MSA Offence or prosecution under the Modern Slavery Act 2015;',
                    },
                  ],
                },
              },
              {
                copy: 'it shall comply with the Modern Slavery Act 2015; and',
              },
              {
                copy: 'it shall notify Kanda immediately in writing if it becomes aware of or has reason to believe that it, or any of its officers, employees, agents or sub-contractors, has breached or potentially breached any of its obligations under this clause 11. Such notice shall set out full details of the circumstances concerning the breach or potential breach.',
              },
            ],
          },
        },
      ],
      prefix: '11',
    },
  ],
};
